module.exports = __webpack_public_path__ + "static/media/homeherobanner.eafbca5b.png";